/**
 * Usp idézet komponens
 */
const MAX_QOUTATIONS = 5;

export const WhyUsQoutationDisplayerComponent = {
	bindings: {
		qoutations: '<',
		analyticsCategory: '@'
	},
	templateUrl: 'why-us-qoutations.html',
	controller: class WhyUsQoutationDisplayerComponent {
		constructor(QoutationService, $scope, $timeout) {
			'ngInject';
			this.qoutationService = QoutationService;
			this.$scope = $scope;
			this.$timeout = $timeout;
		}

		$onChanges(changes) {
			if (changes.qoutations && !changes.qoutations.isFirstChange() && this.qoutations.length) {
				this.qoutationList = angular.copy(this.qoutations);
			}
		}

		$onInit() {
			if (!this.qoutationList) {
				this.qoutationService.getUspQuotations().then((response) => {
					this.qoutationList = angular.copy(response.data);
					if (this.qoutationList.length > MAX_QOUTATIONS) {
						let shuffled = this.shuffledList(this.qoutationList);
						this.qoutationList = shuffled.slice(0, MAX_QOUTATIONS);
					}
				}).catch((err) => {
					console.log(err);
				});
			}
		}

		shuffledList(array) {
			return array.sort(() => Math.random() - 0.5);
		}

	}
};
